
type LoadingListener = (isLoading: boolean) => void;

class LoadingManager {
  private listeners: Set<LoadingListener> = new Set();
  private activeRequests: Set<number> = new Set();
  private requestIdCounter = 0;
  private isLoading = false;
  private showTimer: NodeJS.Timeout | null = null;

  subscribe(listener: LoadingListener): () => void {
    this.listeners.add(listener);
    listener(this.isLoading);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(isLoading: boolean) {
    if (this.isLoading === isLoading) {
      return;
    }
    this.isLoading = isLoading;
    this.listeners.forEach(listener => listener(isLoading));
  }

  startLoading(): number {
    const requestId = ++this.requestIdCounter;
    this.activeRequests.add(requestId);
    
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }
    
    if (this.activeRequests.size === 1) {
      this.notify(true);
    }
    
    return requestId;
  }

  stopLoading(requestId: number) {
    if (!this.activeRequests.has(requestId)) {
      return;
    }

    this.activeRequests.delete(requestId);

    if (this.activeRequests.size === 0) {
      this.notify(false);
    }
  }
}

export const loadingManager = new LoadingManager();
